module.exports = __webpack_public_path__ + "img/HB11X5.png";